import { render, staticRenderFns } from "./Distribuciones.vue?vue&type=template&id=d194a0f4"
import script from "./Distribuciones.vue?vue&type=script&lang=js"
export * from "./Distribuciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports